import IssueGenericLoading from './IssueGenericLoading';

/**
 * Displays the loading state for a vulnerability issue.
 */
const VulnerabilityIssueLoading = () => {
  return (
    <IssueGenericLoading>
      {(contentStartY) => {
        return (
          <>
            {/* Issue Details */}
            <rect x="0" y={contentStartY + 70} rx="3" ry="3" width="95%" height="140" />
            {/* Remediation */}
            <rect x="0" y={contentStartY + 220} rx="3" ry="3" width="95%" height="400" />
            {/* Vulnerable Dependency */}
            <rect x="0" y={contentStartY + 630} rx="3" ry="3" width="95%" height="140" />
            {/* Details */}
            <rect x="0" y={contentStartY + 780} rx="3" ry="3" width="95%" height="140" />
            {/* NVD Base Metrics */}
            <rect x="0" y={contentStartY + 930} rx="3" ry="3" width="95%" height="140" />
            {/* References */}
            <rect x="0" y={contentStartY + 1080} rx="3" ry="3" width="95%" height="400" />
          </>
        );
      }}
    </IssueGenericLoading>
  );
};

export default VulnerabilityIssueLoading;
